/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { isEmpty, isNil } from 'lodash';

/**
 * Map boolean values to 'Y/N' because analytics can't support.
 *
 * @param {Boolean} value
 * @return {string} true/'Y' or false/'N'
 */
export const booleanToYN = (value) => {
  if (isNil(value)) {
    return 'N';
  }
  return value ? 'Y' : 'N';
};

const NEW_1_CUSTOMER = 'NEW1';
const NEW_2_CUSTOMER = 'NEW2';
const CORE_CUSTOMER = 'CORE';
const PREFERED_CUSTOMER = 'PFD';
const HIGH_NET_WORTH = 'HNW';
const MILLION_CUSTOMER = 'MIL';
const VIP_CUSTOMER = 'VIP';

export const customerSegment = {
  5: NEW_1_CUSTOMER,
  6: NEW_2_CUSTOMER,
  7: CORE_CUSTOMER,
  8: PREFERED_CUSTOMER,
  9: HIGH_NET_WORTH,
  10: MILLION_CUSTOMER,
  11: VIP_CUSTOMER
};

export const customerSegmentName = (value) => {
  return customerSegment[value] || CORE_CUSTOMER;
};

/**
  @deprecated use toDelimitedString instead - it comes with more options
*/
export const commaSeparatedList = (list, oxfordComma = false) => {
  if (isEmpty(list)) {
    return '';
  } else if (list.length > 2) {
    const lastItem = list.slice(-1)[0];
    const commaList = list.slice(0, list.length - 1).join(', ');
    return `${commaList}${oxfordComma ? ',' : ''} and ${lastItem}`;
  }

  return list.join(' and ');
};

const DELIMITERS = {
  COMMA: 'comma',
  OXFORD_COMMA: 'oxfordComma',
  AND: 'and',
  WHITESPACE: 'space'
};

/**

Returns String using preset delimiter or custom delimiter against a provided list


@param {array} list the items you want concatenated and delimited.
@param {string} delimiter The char/pattern you want to delimit the list string - see DELIMITERS const
@return {string} delimitedString the concatenated and delimited string.

Example Usage: toDelimitedString(['a', 'b', 'c'], DELIMITER.WHITESPACE) = "a b c"
*/
export const toDelimitedString = (list, delimiter) => {
  if (isEmpty(list)) {
    return '';
  }

  switch (true) {
    case delimiter === DELIMITERS.COMMA:
      return list.slice(0, list.length).join(', ');
    case delimiter === DELIMITERS.AND:
      return commaSeparatedList(list, false);
    case delimiter === DELIMITERS.OXFORD_COMMA:
      return commaSeparatedList(list, true);
    case delimiter === DELIMITERS.WHITESPACE:
      return list.join(' ');
    // if unsupported delimiter type we will assume to be custom delimiter to be applied
    default:
      return list.join(delimiter);
  }
};

export const trimString = (input) => {
  if (!input) {
    return '';
  }
  return input.trim();
};

export const camelCaseToLabelName = (field) => {
  const spaced = field.replace(/([A-Z])/g, ' $1');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};
